import * as React from 'react'

interface IProps {
  size?: number
  onClick: () => void
  className?: string
}

const CloseIcon: React.FunctionComponent<IProps> = ({ size = 14, onClick, className }) => (
  // tslint:disable:max-line-length
  <svg
    className={className}
    onClick={onClick}
    viewBox="0 0 14 14"
    width={size}
    height={size}
    style={{ cursor: 'pointer' }}
  >
    <polygon
      fillOpacity=".25"
      transform="translate(-5 -5)"
      points="18.969 6.406 13.391 11.984 18.969 17.563 17.563 18.969 11.984 13.391 6.406 18.969 5 17.563 10.578 11.984 5 6.406 6.406 5 11.984 10.578 17.563 5"
    />
  </svg>
)

export default React.memo(CloseIcon)
